export default {
   page0: {
      description: 'Join Mind Makers for Bytes & Bubbles- our first ever social fundraiser! Our engineering team has been working hard, building prototypes for two fun installations- a robotic, customizable  photo booth and an interactive dance floor. Meet and mingle with Mind Makers and help us make engineering accessible for all!',
      image: 'https://github.com/MindMakersProject/website-BE/blob/master/photos/banners/MindMakers_2880x854_BytesBubbles.jpg?raw=true',
      title: 'Bytes and Bubbles',
      button: 'Sign Up Now',
      link: ' https://www.eventbrite.com/e/mind-makers-presents-bytes-bubbles-tickets-45655808753'
  },
  page1: {
      description: "The Mind Makers team is headed back to NASA HQ to welcome the next class of Datanauts! The Datanauts' program goal is to attract data newcomers, introduce and advance data science skills, and create a vibrant data problem-solving community.",
      image: 'https://github.com/MindMakersProject/website-BE/blob/master/photos/banners/MindMakers_2880x854_Datanauts.jpg?raw=true',
      title: 'Spring 2018 NASA Datanauts Kickoff',
      button: 'Learn More',
      link: '/outreach/nasa-datanauts-spring'
  },
  page2: {
    description: 'Newcomers join alumni from our Taste of STEM workshop, together diving into software development for hardware. Alumni bring their taste buds back to tune up and newcomers get set up with a fresh electronics kit to build on!',
    image: 'https://github.com/MindMakersProject/website-BE/blob/master/photos/banners/MindMakers_IntroToProgramming.jpg?raw=true',
    title: 'Intro To Programming',
    button: 'Learn More',
    link: '/outreach/intro-to-programming'
  },
  page3: {
    description: 'Walk in with no tech background but ready to learn. Walk out with a reprogrammable electronics project that you brought to life!',
    image: 'https://github.com/MindMakersProject/website-BE/blob/master/photos/banners/MindMakers_TasteofSTEM_2880x254.jpg?raw=true',
    title: 'A Taste of STEM',
    button: 'Learn More',
    link: '/outreach/taste-of-stem'
  },
  page4: {
    description: 'Learn more about us and our team.',
    image: 'https://github.com/MindMakersProject/website-BE/blob/master/photos/banners/MindMakers_welcome_2880x854.jpg?raw=true',
    title: 'Welcome to Mind Makers!',
    button: 'Learn More',
    link: '/about'
  }
}


// WEBPACK FOOTER //
// ./src/configs/hero-banner-config.js